<div class="card" *ngIf="!isMockUp; else mockupCard">
  <div [ngClass]="card.DatePictoColor" class="card__side_ribbon"></div>
   
  <div class="card__body">
    <div class="card__title q-c-main q-bold card__title--2line" title="{{card.Titre}}"><span class="q-c-light-black">{{card.NumStage}} -</span> {{card.Titre}}</div>
    <div class="card__date mb-1"> {{card.DateDebut|qDateShort}} <span *ngIf="card.DateFin">&#8594;</span> {{card.DateFin|qDateShort}}   <span *ngIf="card.Cloture" class="float-right q-text-s q-bold q-c-secondary">Cloturé</span></div>
    <div class="card__text mb-1">{{card.CpVille}}</div>
    <div class="card__text  mt-2 card__text--lean card__text--client" [title]="card.ClientTitle">
      <span *ngFor="let client of card.Client">{{client.SocialReason}}</span>
    </div>
  </div>
  <div class="card__footer">
    <div class="footer__price">
      <img *ngFor="let formateur of card.FormateurToDisplay" [src]="formateur.ProfilePicture" loading="lazy" title="{{formateur.Firstname}} {{formateur.Lastname}}" />
      <span class="card__photo-hint" *ngIf="card.FormateurPictoHint > 0" [title]="card.FormateurPictoTitle"><div>+{{card.FormateurPictoHint}}</div></span>

    </div>
    <div class="footer__picto">     
      <div class="q-bold" [ngClass]="card.MontantPictoColor" [title]="card.MontantPictoTitle" >{{indParam.AppParams.Devise}}</div>
      <div title="{{card.NbPreinscrit}} préinscrit.e.s"><i class="fas fa-cart-arrow-down"></i><span>{{card.NbPreinscrit}}</span></div>
      <div title="{{card.NbStagiaire}} apprenant.e.s"><i class="fas fa-graduation-cap"></i><span>{{card.NbStagiaire}}</span></div>
    </div>
  </div>
</div>


<ng-template #mockupCard>
  <div class="card mockup">
    <div class="placeholder card__side_ribbon"></div>
    <div class="card__body">
      <div class="card__title q-c-main q-bold m-0 mb-1 d-flex row">
        <div class="placeholder q-c-light-black col-2"></div>
        <div class="placeholder col-2"></div>
        <div class="placeholder col-3"></div>
        <div class="placeholder col-1"></div>
        <div class="placeholder col-1"></div>
      </div>
      <div class="card__date mb-1 row mx-0">
        <div class="placeholder col-3"></div>
        <div class="placeholder col-1"></div>
        <div class="placeholder col-3"></div>
      </div>
      <div class="card__text q-c-light-black mb-1 row mx-0">
        <div class="placeholder col-2"></div>
        <div class="placeholder col-3"></div>
      </div>
      <div class="card__text card__text--flex mt-2 q-bold">
        <div>
          <div class="placeholder col-2"></div>
          <div class="placeholder col-2"></div>
        </div>
      </div>
    </div>
    <div class="card__footer">
      <div class="footer__price">
        <img class="placeholder" />
      </div>
      <div class="footer__picto row mx-0">
        <div class="placeholder col-2"></div>
        <div class="placeholder col-2"></div>
        <div class="placeholder col-2"></div>
        <div class="placeholder col-2"></div>
      </div>
    </div>
  </div>
</ng-template>
